import { poreskaUpravaRepo } from "./poreskaUprava.repo";
import { PuObrazacListPayload } from "./poreskaUprava.types";

class PoreskaUpravaService {
  getPuObrasci = (payload: PuObrazacListPayload) => {
    return poreskaUpravaRepo.getPuObrasci(payload);
  };

  getSinglePuObrazac = (obrazacId: number) => {
    return poreskaUpravaRepo.getSinglePuObrazac(obrazacId);
  };
}

export const poreskaUpravaService = new PoreskaUpravaService();
